module.exports = __webpack_public_path__ + "media/reskin-images/img--no-picture-7336540e.jpeg";